module.exports = __webpack_public_path__ + "static/media/GPlay.dba8fd4d.png";